import React from 'react';
import { Hero } from './components/sections/Hero';
import { PainPoints } from './components/sections/PainPoints';
import { Benefits } from './components/sections/Benefits';
import { Product } from './components/sections/Product';
import { Guarantee } from './components/sections/Guarantee';
import { Bonuses } from './components/sections/Bonuses';
import { Reviews } from './components/sections/Reviews';
import { FAQ } from './components/sections/FAQ';
import { PurchasePopup } from './components/PurchasePopup';
import { MetaPixel } from './components/analytics/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-stone-100 flex justify-center font-sans" data-id="element-0">
      <MetaPixel data-id="element-1" />
      {/* Mobile container constraint for desktop viewing */}
      <div className="w-full max-w-md bg-[#FAF5FF] shadow-2xl relative overflow-hidden" data-id="element-2">
        <Hero data-id="element-3" />
        <PainPoints data-id="element-4" />
        <Benefits data-id="element-5" />
        <Product data-id="element-6" />
        <Guarantee data-id="element-7" />
        <Bonuses data-id="element-8" />
        <Reviews data-id="element-9" />
        <FAQ data-id="element-10" />
        <PurchasePopup data-id="element-11" />
      </div>
    </div>;
}